import addPopover from "../dom/addPopover";

export default function addMicroscriptPopOver() {
	addPopover(
		"microscript",
		".pplr-micro",
		"Micro",
		"Outlines are not available on Micro Script or Micro Block.",
		"bottom",
	);
}
